import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "bg-white" }
const _hoisted_2 = {
  scope: "col",
  class: "px-6 py-3.5 relative",
  style: {"z-index":"0"}
}
const _hoisted_3 = {
  scope: "col",
  class: "px-6 py-3.5 relative",
  style: {"z-index":"0"}
}
const _hoisted_4 = {
  scope: "col",
  class: "px-6 py-3.5 relative",
  style: {"z-index":"0"}
}
const _hoisted_5 = {
  scope: "col",
  class: "px-6 py-3.5 relative",
  style: {"z-index":"0"}
}
const _hoisted_6 = /*#__PURE__*/_createElementVNode("th", {
  scope: "col",
  class: "px-6 py-3.5 text-left text-xs font-medium text-blue-900 uppercase tracking-wider"
}, " UID ", -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_InputField = _resolveComponent("InputField")!

  return (_openBlock(), _createElementBlock("thead", _hoisted_1, [
    _createElementVNode("tr", null, [
      _createElementVNode("th", _hoisted_2, [
        _createVNode(_component_InputField, {
          label: "Kliinik",
          value: _ctx.clinicName,
          "onUpdate:value": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.clinicName) = $event))
        }, null, 8, ["value"])
      ]),
      _createElementVNode("th", _hoisted_3, [
        _createVNode(_component_InputField, {
          label: "Kabinet",
          value: _ctx.cabinetName,
          "onUpdate:value": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.cabinetName) = $event))
        }, null, 8, ["value"])
      ]),
      _createElementVNode("th", _hoisted_4, [
        _createVNode(_component_InputField, {
          label: "Seade",
          value: _ctx.equipmentName,
          "onUpdate:value": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.equipmentName) = $event))
        }, null, 8, ["value"])
      ]),
      _createElementVNode("th", _hoisted_5, [
        _createVNode(_component_InputField, {
          label: "Ülesvõtte liik",
          value: _ctx.imageName,
          "onUpdate:value": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.imageName) = $event))
        }, null, 8, ["value"])
      ]),
      _hoisted_6
    ])
  ]))
}